import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import {
  viewerPhotoDocumentRejectInit,
  viewerPhotoDocumentReject,
} from '../../actions/Viewer/ViewerActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
} from './PhotoDocumentReject.style';

const PhotoDocumentRejectInner = ({
  id,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const dispatch = useDispatch();
  const firebaseStore = useSelector((state) => state.firebase);
  const { profile } = firebaseStore;
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const viewerPhotoDocumentRejectStore = useSelector(
    (state) => state.viewerPhotoDocumentRejectStore
  );
  const {
    isLoading,
    isSuccess,
    isError,
    error,
  } = viewerPhotoDocumentRejectStore;

  const onSubmit = (e) => {
    e.preventDefault();
    if (isProfileCompany) {
      dispatch(viewerPhotoDocumentReject({ id }));
    }
  };

  useEffect(() => {
    dispatch(viewerPhotoDocumentRejectInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleProcess(isLoading ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, isError]);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.photoDocumentReject.wrapper}>
        <Header theme={theme.photoDocumentReject.header}>
          <Title theme={theme.photoDocumentReject.title}>
            {intl.formatMessage({
              id: 'REJECT_PHOTO_DOCUMENT.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.photoDocumentReject.text.default}>
                {intl.formatMessage({
                  id: `REJECT_PHOTO_DOCUMENT.TEXT.THE_PHOTO_DOCUMENT_HAS_BEEN_SUCCESSFULLY_REJECTED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => handleClose()}
          >
            {intl.formatMessage({ id: 'REJECT_PHOTO_DOCUMENT.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={onSubmit}>
          <Wrapper theme={theme.photoDocumentReject.wrapper}>
            <Header theme={theme.photoDocumentReject.header}>
              <Title theme={theme.photoDocumentReject.title}>
                {intl.formatMessage({
                  id: 'REJECT_PHOTO_DOCUMENT.REJECT_PHOTO_DOCUMENT',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Textbox center>
                  <Text theme={theme.photoDocumentReject.text.default}>
                    {intl.formatMessage({
                      id: `REJECT_PHOTO_DOCUMENT.TEXT.ARE_YOU_SURE_WANT_TO_REJECT_PHOTO_DOCUMENT`,
                    })}
                    <br />
                    {intl.formatMessage({
                      id: `REJECT_PHOTO_DOCUMENT.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                    })}
                  </Text>
                </Textbox>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.photoDocumentReject.text.error}>
                  {intl.formatMessage({
                    id: `REJECT_PHOTO_DOCUMENT.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => handleClose()}
              >
                {intl.formatMessage({ id: 'REJECT_PHOTO_DOCUMENT.CANCEL' })}
              </Button>
              <Button theme={theme.button.default} disabled={isLoading}>
                {isLoading
                  ? intl.formatMessage({
                      id: 'REJECT_PHOTO_DOCUMENT.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `REJECT_PHOTO_DOCUMENT.REJECT`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const PhotoDocumentReject = ({
  id,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  return (
    <Modal handleClose={handleClose}>
      <PhotoDocumentRejectInner
        id={id}
        handleClose={handleClose}
        handleProcess={handleProcess}
      />
    </Modal>
  );
};

PhotoDocumentRejectInner.propTypes = {
  id: PropTypes.string,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

PhotoDocumentReject.propTypes = {
  id: PropTypes.string,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

export default PhotoDocumentReject;
